import { useEffect, useMemo, useRef, useState } from "react";
import { Form } from "antd";
import SignatureCanvas from "react-signature-canvas";

// A report template's Signature field. The drawing is handed back as a PNG File, so the
// report pages upload it under dutyreport/ like a photo answer and store its key - which
// filesURL, the duty report PDF and the app all show as an image. `value` is that key once
// saved (shown from `fileUrl`), a File while freshly drawn, or blank.
export const ReportSignatureField = ({ label, name, value, fileUrl, handelDataValue, labelExtra = null }) => {
    const box = useRef(null);
    const pad = useRef(null);
    const [width, setWidth] = useState(0);
    // true from the first stroke on, so the pad isn't swapped for a preview mid-signature
    const [drawing, setDrawing] = useState(false);

    const drawnUrl = useMemo(() => (value instanceof Blob ? URL.createObjectURL(value) : null), [value]);
    useEffect(() => () => { if (drawnUrl) URL.revokeObjectURL(drawnUrl); }, [drawnUrl]);

    const previewUrl = drawing ? null : drawnUrl || (typeof value === "string" && value ? fileUrl : null);

    useEffect(() => {
        if (!previewUrl && box.current) setWidth(Math.floor(box.current.clientWidth));
    }, [previewUrl]);

    const report = () => {
        if (!pad.current || pad.current.isEmpty()) return handelDataValue({ name, value: "" });
        let canvas;
        try { canvas = pad.current.getTrimmedCanvas(); } catch { canvas = pad.current.getCanvas(); }
        canvas.toBlob((blob) => {
            if (blob) handelDataValue({ name, value: new File([blob], `signature-${name}-${Date.now()}.png`, { type: "image/png" }) });
        }, "image/png");
    };

    const signAgain = () => {
        setDrawing(true);
        handelDataValue({ name, value: "" });
    };

    return (
        <Form.Item>
            <label>{label} {labelExtra}</label>
            {previewUrl ?
                <div>
                    <div className="report-sign-pad">
                        <img src={previewUrl} alt={label} className="report-sign-img" />
                    </div>
                    <div className="report-sign-bar">
                        <span className="report-sign-hint">Signed</span>
                        <span className="link cursor" onClick={signAgain}>Sign again</span>
                    </div>
                </div>
                :
                <div>
                    <div className="report-sign-pad" ref={box}>
                        {width > 0 &&
                            <SignatureCanvas
                                ref={pad}
                                penColor="#111827"
                                canvasProps={{ width, height: 150, className: "report-sign-canvas" }}
                                onBegin={() => setDrawing(true)}
                                onEnd={report}
                            />
                        }
                    </div>
                    <div className="report-sign-bar">
                        <span className="report-sign-hint">Sign in the box</span>
                        <span className="link cursor" onClick={() => { pad.current?.clear(); report(); }}>Clear</span>
                    </div>
                </div>
            }
        </Form.Item>
    );
};
